<template>
  <v-container fluid fill-height>
    <v-row>
      <v-col cols="12" xs="12" md="4" xl="4" class="mx-auto">
        <div id="pdfvuer">
          <pdf
            :src="pdfdata"
            v-for="i in numPages"
            :key="i"
            :id="i"
            :page="i"
            :scale.sync="scale"
            style="width: 100%; margin: 20px auto"
            :annotation="true"
            :resize="true"
            @link-clicked="handle_pdf_link"
          >
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import pdfvuer from "pdfvuer";
import "pdfjs-dist/build/pdf.worker.entry"; // not needed since v1.9.1

export default {
  components: {
    pdf: pdfvuer,
  },
  data() {
    return {
      page: 1,
      numPages: 0,
      pdfdata: "VolantinoAperitivo2.pdf",
      errors: [],
      scale: "page-width",
    };
  },
  mounted() {
    this.getPdf();
  },
  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
  },
  methods: {
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    getPdf() {
      var self = this;
      self.pdfdata = pdfvuer.createLoadingTask("VolantinoAperitivo2.pdf");
      self.pdfdata.then((pdf) => {
        self.numPages = pdf.numPages;
      });
    },
  },
};
</script>
